<template>
  <div class="Flex">
    <div class="hc-percentage-box">
      {{currencyType}}
    </div>
    <AmountInput
      style="width: 100px"
      size="small"
      class="account-input"
      :decimal="decimal"
      :amount.sync="amountInner"
      :minValue="minValue"
    ></AmountInput>
  </div>
</template>

<script>
export default {
  props: {
    currencyType: [String],
    minValue: {
      type: Number,
      default: 1
    },
    decimal: {
      type: Number,
      default: 2
    },
  },
  // emits: ['update:amount'],
  data() {
    return {

    }
  },
  computed: {
    amountInner: {
      get() {
        return this.amount
      },
      set(val) {
        this.$emit('update:amount', val)
      }
    }
  },
  mounted() {
  },

  methods: {

  }
}
</script>

<style scoped lang='scss'>
.Flex {
  display: flex;
  // align-items: center;
}

</style>
